import { createContext } from "react";

export const LanguageContext = createContext(0); //0 : English, 1 : 한국어
